import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "redText",
  style: {"margin-bottom":"5px"}
}
const _hoisted_2 = { class: "alternating-table" }
const _hoisted_3 = { class: "flex-container-row gap5 padv2" }
const _hoisted_4 = { class: "flex-container-col" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  style: {"font-size":"smaller"}
}
const _hoisted_7 = { class: "alternating-table" }
const _hoisted_8 = { class: "flex-container-row gap5 padv2" }
const _hoisted_9 = { class: "flex-container-col" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  style: {"font-size":"smaller"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bom_icon = _resolveComponent("bom-icon")!
  const _component_card_title = _resolveComponent("card-title")!
  const _component_card_header = _resolveComponent("card-header")!
  const _component_doc_icon = _resolveComponent("doc-icon")!
  const _component_card_body = _resolveComponent("card-body")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_card_header, {
        class: _normalizeClass(['k-hstack', 'subsection', `bom-accent-${_ctx.avatar}`])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bom_icon, {
            type: _ctx.avatar,
            size: 20
          }, null, 8, ["type"]),
          _createVNode(_component_card_title, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.title), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_card_body, null, {
        default: _withCtx(() => [
          (_ctx.comment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.comment), 1))
            : _createCommentVNode("", true),
          _createElementVNode("table", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nonAlternativeMaterials, (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.id
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_doc_icon, {
                      "material-data": item,
                      "fill-space": true,
                      icon: "attachment",
                      color: "black"
                    }, null, 8, ["material-data"]),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("a", {
                        href: "#",
                        class: _normalizeClass([item.hiddenSparePart ? 'hidden-material' : '', "textlink"]),
                        onClick: _withModifiers(($event: any) => (_ctx.onClick(item)), ["prevent"])
                      }, _toDisplayString(_ctx.materialText(item)) + " " + _toDisplayString(_ctx.materialCountText(item)), 11, _hoisted_5),
                      (_ctx.materialSalesText(item))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.materialSalesText(item)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alternatives, (alternative) => {
            return (_openBlock(), _createBlock(_component_card, {
              key: alternative.alternativeText
            }, {
              default: _withCtx(() => [
                _createVNode(_component_card_header, { class: "k-hstack subsection bom-accent-alternative-bom" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_bom_icon, {
                      type: "alternative-bom",
                      size: 20
                    }),
                    _createVNode(_component_card_title, { style: {"font-weight":"normal"} }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.localize('alternative')) + " " + _toDisplayString(alternative.alternativeText), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_card_body, null, {
                  default: _withCtx(() => [
                    _createElementVNode("table", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alternative.materials, (item) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.id
                        }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(_component_doc_icon, {
                                "material-data": item,
                                "fill-space": true,
                                icon: "attachment",
                                color: "black"
                              }, null, 8, ["material-data"]),
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("a", {
                                  href: "#",
                                  class: _normalizeClass([item.hiddenSparePart ? 'hidden-material' : '', "textlink"]),
                                  onClick: _withModifiers(($event: any) => (_ctx.onClick(item)), ["prevent"])
                                }, _toDisplayString(_ctx.materialText(item)) + " " + _toDisplayString(_ctx.materialCountText(item)), 11, _hoisted_10),
                                (_ctx.materialSalesText(item))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.materialSalesText(item)), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}